import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AlertService, MessageSeverity } from 'src/app/services/alert.service';
import { AauthService } from 'src/app/services/aauth.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { UserLogin } from 'src/app/models/user-login.model';
import { User } from 'src/app/models/user.model';
import { LoginReturn } from 'src/app/models/login.return.model';
import { ParamMap, Router, ActivatedRoute } from '@angular/router';

declare function InitMyJs(): void;                                                                                      // fake to skip ide error.

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit, OnDestroy {
  userLogin = new UserLogin();
  isLoading = false;
  isFlyout = false;
  formResetToggle = true;
  inLogin = window.sessionStorage.getItem('inLogin');
  modalClosedCallback: () => void;
  loginStatusSubscription: any;

  @Input()
  isModal = false;

  constructor(
    private alertService: AlertService,
    private authService: AauthService,
    public configurationService: ConfigurationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    try {
      InitMyJs();
    } catch (error) {
      console.error(error);
    }
    this.userLogin.rememberMe = true;                                                                                  // this.authService.rememberMe;

    this.route.queryParams.subscribe(params => {
      const flyout = params['fly'];
      if (flyout === '1') {
        this.isFlyout = true;
      }
    });

    if (this.getShouldRedirect()) {
      this.authService.redirectLoginUser();
    } else {
      this.loginStatusSubscription = this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
        if (this.getShouldRedirect()) {
          this.authService.redirectLoginUser();
        }
      });
    }

    // @TODO remove when done with new. back compatible run with old header. footer. remove old footer & new header.
    const el = document.getElementsByClassName('rankipedia-footer');
    if (el[0]) {
      $(el[0]).addClass('condensed');
      const elH = document.getElementsByClassName('site-nav');
      if (elH[0]) {
        $(elH[0]).addClass('condensed');
      }
    }
  }

  getShouldRedirect() {
    return !this.isModal && this.authService.isLoggedIn && !this.authService.isSessionExpired;
  }

  ngOnDestroy() {
    if (this.loginStatusSubscription) {
      this.loginStatusSubscription.unsubscribe();
    }

    const el = document.getElementsByClassName('rankipedia-footer');
    if (el[0]) {
      $(el[0]).removeClass('condensed');
      const elH = document.getElementsByClassName('site-nav');
      if (elH[0]) {
        $(elH[0]).removeClass('condensed');
      }
    }
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  signInWithFB() {
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    try {
      this.authService.signInWithFB().then(() => {
        if (this.authService.isLoggedIn) {
          this.onLoginsucceed(this.authService.currentUser, '');
          // this.authService.gotoHomePage()
        } else {
          this.onLoginFail('Logon error');
        }
      }
      )
        .catch(e => {
          this.onLoginFail(e);
        });
    } catch (error) {
      this.onLoginFail(error);
    }
  }

  signInWithGoogle() {
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    try {
      this.authService.signInWithGoogle()
        .then(() => {
          // console.log(this.authService.currentUser);
          if (this.authService.isLoggedIn) {
            this.onLoginsucceed(this.authService.currentUser, '');
          } else {
            this.onLoginFail('Logon error');
          }
        })
        .catch(e => {
          this.onLoginFail(e);
        });
    } catch (error) {
      this.onLoginFail(error);
    }
  }

  onSubmit() {
    if (this.userLogin.userName === '') {
      this.alertService.showWarning('User name required!');
      const ctrUserName = document.getElementById('login-email');
      ctrUserName.focus();
      return;
    }

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    this.authService.login(this.userLogin.userName, this.userLogin.password, this.userLogin.rememberMe)
      .then((data) => {
        const loginReturn = data as LoginReturn;
        console.log('login returns: ' + loginReturn.url);
        if (this.authService.isLoggedIn) {
          this.onLoginsucceed(this.authService.currentUser, loginReturn.url);
        } else {
          this.onLoginFail('Logon error');
        }
      })
      .catch(e => {
        this.onLoginFail(e);
      });
  }

  onLoginFail(error: any) {
    this.alertService.stopLoadingMessage();
    this.authService.ShowErrorMessage(error);

    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }

  mapLoginErrorMessage(errorMessage: string): string {
    if (errorMessage === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (errorMessage === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return errorMessage;
  }

  recoverPassword() {
    this.authService.gotoRecoverPassword(this.isFlyout);
  }

  gotoRegister() {
    this.authService.gotoRegister();
  }

  onLoginsucceed(user: User, fwdUrl: string) {
    // setTimeout(() => {
    if ((fwdUrl === null) || (fwdUrl === '')) {
      fwdUrl = '/';
    }
    this.alertService.stopLoadingMessage();
    this.isLoading = false;
    this.reset();
    if ((!this.isModal) && (!this.isFlyout)) {
      this.alertService.showMessage('Login', `Welcome ${user.fullName || ''}!`, MessageSeverity.success);
      if (fwdUrl === '/Home/') {
        fwdUrl = '/Page';
      } else if (fwdUrl === undefined || fwdUrl === null) {
        fwdUrl = window.localStorage.getItem('previousURLLogin');
      }
      this.forwardAfterLogin(fwdUrl);
    } else {
      if (this.isModal) {
        this.alertService.showMessage('Login', `Session for ${user.fullName || ''} restored!`, MessageSeverity.success);
        setTimeout(() => {
          this.alertService.showStickyMessage('Session Restored', 'Please try your last operation again', MessageSeverity.default);
        }, 500);
        this.closeModal();
      } else {
        // force the click - hack to pass an event from ang 9 back to script file in non-angular
        // 10-17-2021 - dwn: changed from .click to .trigger('click')
        $('#btnCallback').trigger('click');
      }
    }
    window.sessionStorage.removeItem('inLogin');                                                                        // handles conditionals to prevent GetSponsoringProfessional()
    // }, 10);
  }

  forwardAfterLogin(defaultUrl) {
    let gotoUrl = defaultUrl;
    if ((gotoUrl === '/') || (gotoUrl === '')) {
      const referrerUrl = window.localStorage.getItem('referUrlLogin');
      if ((referrerUrl != null) && (referrerUrl !== undefined)) {
        gotoUrl = referrerUrl;
        window.localStorage.setItem('referUrlLogin', null);
      }
    } else if ((gotoUrl === '/Page') || (gotoUrl === '/Page#') || (gotoUrl === '/Page#/')) {
      gotoUrl = '/Home/';
    }
    this.authService.locationTo(gotoUrl);
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
}
